import { IconContext, type IconProps } from "@phosphor-icons/react";
import { useMemo, type PropsWithChildren } from "react";

type Props = PropsWithChildren;

export function IconContextProvider({ children }: Props) {
  const contextValue = useMemo<IconProps>(
    () => ({
      "aria-hidden": true,
    }),
    [],
  );

  return <IconContext value={contextValue}>{children}</IconContext>;
}
